exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-move-to-wait{width:100%;max-width:600px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/components/common/MoveToWaitModal/style.css
// module id = 1240
// module chunks = 0